// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"PageNotFound_pageNotFound__2axHm"};